import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import Typography from 'Components/UI/Typography';
import Button from 'Components/UI/Button';
import LoadingIndicator from 'Components/UI/LoadingIndicator';
import { Tooltip } from '@material-ui/core';

const styles = theme => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
    marginTop: theme.spacing(2),
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
  },
  table: {
    overflow: 'scroll',
    flexBasis: '19em',
    marginLeft: theme.spacing(2),
  },
  row: {
    display: 'flex',
    flexFlow: 'row',
    alignItems: 'center',
    marginTop: theme.spacing(1),
  },
  column: {
    flex: 1,
    textAlign: 'right',
  },
  status: {
    borderRadius: theme.radius.lg,
    backgroundColor: theme.palette.facet.accentGreen2,
    minWidth: '100px',
    textAlign: 'center',
  },
  statusText: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  statusBankAccountType: {
    marginLeft: theme.spacing(2),
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.facet.darkGray,
  },
  statusNickName: {
    marginLeft: theme.spacing(2),
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.facet.darkGray,
    maxWidth: '100px',
  },
  activeStatus: {
    marginLeft: theme.spacing(2),
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.facet.darkGray,
  },
});

const View = ({
  classes, rows, loading, onClick, amplitudeRootNodeProps,
}) => {
  return (
    <Box className={classes.root} debugColor="chartreuse" {...amplitudeRootNodeProps}>
      <Typography
        variant="h3"
        color="primary"
        className={classes.title}
      >
        ACH Relationships
      </Typography>
      <div className={classes.table}>
        {loading ? (<LoadingIndicator />) : rows.map(row => (
          <div className={classes.row}>
            <div className={classes.column}>
              <Button
                className={classes.status}
                style={{
                  backgroundColor: row.statusColors.backgroundColor,
                }}
                onClick={() => onClick(row.resource)}
              >
                <Typography
                  className={classes.statusText}
                  variant="h6"
                  color={row.statusColors.textColor}
                >
                  {row.status}
                </Typography>
              </Button>
            </div>
            <div className={classes.column}>
              <Typography
                className={classes.statusBankAccountType}
                variant="h6"
              >
                {row.bankAccountType}
              </Typography>
            </div>
            <div className={classes.column}>
              <Typography
                className={classes.activeStatus}
                variant="h6"
              >
                {row.activeStatus}
              </Typography>
            </div>
            <div className={classes.column}>
              <Tooltip title={row.nickName} arrow placement="top-end">
                <Typography
                  className={classes.statusNickName}
                  variant="h6"
                  noWrap
                >
                  {row.nickName}
                </Typography>
              </Tooltip>
            </div>
          </div>
        ))}
      </div>
    </Box>
  );
};

View.propTypes = {
  classes: PropTypes.object.isRequired,
  rows: PropTypes.array,
  loading: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  amplitudeRootNodeProps: PropTypes.object.isRequired,
};
View.defaultProps = {
  rows: [],
  loading: false,
};

export default withStyles(styles)(View);
